import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["placeholder", "formAction", "className", "inputType", "icon", "onSubmitAction", "buttonVariant", "dataContentPiece"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as o, jsxs as l } from "react/jsx-runtime";
import b from "react";
import { InputText as _ } from "../Inputs/InputText/InputText.js";
import { c as v } from "../../clsx-OuTLNxxd.js";
import { Button as x } from "../../Button/Button.js";
const f = "InputForm-module_input-container__uybo3",
  C = "InputForm-module_submit-button__YjMeM",
  F = "InputForm-module_input__ParxB",
  a = {
    inputContainer: f,
    submitButton: C,
    input: F
  },
  N = _ref => {
    let {
      condition: i,
      children: t,
      props: n
    } = _ref;
    return i ? /* @__PURE__ */o("form", {
      className: v(a.inputContainer, n.className),
      action: n.formAction,
      onSubmit: n.onSubmitAction,
      children: t
    }) : /* @__PURE__ */o("div", {
      className: a.inputContainer,
      children: t
    });
  },
  g = _ref2 => {
    let {
        placeholder: i,
        formAction: t = void 0,
        className: n,
        inputType: m = "text",
        icon: r = "action",
        onSubmitAction: s = void 0,
        buttonVariant: u = "transparent",
        dataContentPiece: c
      } = _ref2,
      e = _objectWithoutProperties(_ref2, _excluded);
    const p = r ? r == "action" ? "chevron-right" : "search" : void 0,
      d = c || e["data-content-piece"];
    return /* @__PURE__ */o(N, {
      condition: !!t,
      props: {
        formAction: t,
        onSubmitAction: s,
        className: n
      },
      children: /* @__PURE__ */l(b.Fragment, {
        children: [/* @__PURE__ */o(_, _objectSpread({
          className: a.input,
          type: m,
          placeholder: i
        }, e)), /* @__PURE__ */o(x, {
          className: a.submitButton,
          iconName: p,
          dataContentPiece: d,
          "aria-label": i,
          variant: "primary",
          inverted: u === "white",
          disabled: e.disabled
        })]
      })
    });
  };
export { g as InputForm };